import { FaExclamationTriangle } from "react-icons/fa";

const ErrorMessage = ({ error, show, bgColor = true }) => {
    return (
        <>
            {show && (
                <div
                    className={`flex flex-col items-center justify-center p-6 rounded-lg  ${
                        bgColor ? "bg-gray-100 shadow-md" : ""
                    }`}
                >
                    <FaExclamationTriangle className="text-red-500 text-3xl mb-3" />
                    <p className="text-red-500 font-semibold text-lg">{error}</p>
                </div>
            )}
        </>
    );
};

export default ErrorMessage;
